export default "__VITE_ASSET__rMmhMjET__"